<template>
  <div class="ticket-head-container">
<!--    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="fetchData">查询</el-button>
      </el-form-item>
    </el-form>-->

    <el-table :data="displayData" border>
      <el-table-column prop="_checked" label="选择" width="80">
        <template #default="{row}">
          <el-checkbox v-model="row._checked" @change="(val) => handleCheckChange(row, val)" />
        </template>
      </el-table-column>
      <el-table-column prop="label" label="字段名称" />
      <!--   是否必填mast（1是0否）   -->
      <el-table-column prop="mast" label="是否必填">
        <template #default="{row}">
          <el-checkbox v-model="row.mast"/>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'TicketHead',
  props: {
    typeId: {
      type: Number
    },
    typeName: {
      type: String
    }
  },
  data() {
    return {
      tableData: [], // 所有查询数据
      displayData: [
        { label: '工单名称', prop: 'name' },
        { label: '单号', prop: 'code' },
        { label: '责任人', prop: 'personResponsible' },
        { label: '提交人', prop: 'submitter' },
        { label: '审核人', prop: 'reviewer' },
        { label: '部门', prop: 'department' },
        { label: '收货时间', prop: 'receiptTime' },
        { label: '收款时间', prop: 'collectionsTime' },
        { label: '票据类型', prop: 'billType' },
        { label: '往来单位', prop: 'correspondents' },
        { label: '流转仓库', prop: 'warehouse' },
        { label: '摘要信息', prop: 'summary' },
        { label: '条码', prop: 'barcodes' },
        { label: '扫描数量', prop: 'scansNumber' },
        { label: '附加说明', prop: 'remark' },
        { label: '销售类型', prop: 'saleType' },
        { label: '付款账户', prop: 'paymentAccount' },
        { label: '付款金额', prop: 'payment' },
        { label: '整单折扣', prop: 'discount' },
        { label: '优惠', prop: 'preferential' },
        { label: '预付金额', prop: 'prepaidAmount' },
      ], // 所有字段
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const res = await requestTicket.post('/Ticketing/ticket-head/findAll')
        this.tableData = res.data.map(item => ({
          ...item,
          _checked: false
        }))
        this.filterData()
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },

    filterData() {
      if (!this.typeId) {
        return
      }
      
      // 根据typeId筛选逻辑（示例筛选逻辑，需根据实际需求调整）
      this.displayData = this.displayData.map(item => {
        const _checked = this.tableData.find(t => {
        return (t.typeId === this.typeId &&
            t.label === item.label &&
            t.prop === item.prop) // 根据label和prop匹配设置选中状态
        })
        if (_checked) {
          return {
            ..._checked,
            _checked: true
          }
        } else {
          return {
            ...item,
            _checked: false
          }
        }
      })
    },

    async handleCheckChange(row, checked) {
      try {
        if (checked) {
          row.typeId = this.typeId
          row.typeName = this.typeName
          await requestTicket.post('/Ticketing/ticket-head/save', row)
        } else {
          await requestTicket.delete(`/Ticketing/ticket-head/${row.id}`)
        }
        await this.fetchData() // 操作后刷新数据
      } catch (error) {
        console.error('操作失败:', error)
        row._checked = !checked // 回滚选中状态
      }
    }
  }
}
</script>

<style scoped>
.ticket-head-container {
  padding: 20px;
}
.el-table {
  margin-top: 20px;
}
</style>